import React, { FC } from 'react';
import { Box, SkeletonGroup, SkeletonLine, Divider } from '@wix/design-system';

const RenderLoadingReview: FC<{}> = () => {
  return (
    <Box width="100%" padding="SP4" direction="vertical">
      <SkeletonGroup skin="light">
        <Box direction="vertical" gap="18px">
          <Box direction="vertical" gap="6px">
            <SkeletonLine width="16%" />
            <SkeletonLine width="30%" />
          </Box>
          <Box direction="vertical" gap="6px">
            <SkeletonLine width="100%" />
            <SkeletonLine width="100%" />
          </Box>
        </Box>
      </SkeletonGroup>
    </Box>
  );
};

export default RenderLoadingReview;
